<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="props">
    <component :is="VisualBinaryTree" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import GravManagerWrapper from './GravManagerWrapper.vue';
import { VisualBinaryTreeProps } from './VisualBinaryTree.ts';
import VisualBinaryTree from './VisualBinaryTree.vue';

import { useChangableProps } from '@/composables/useChangableProps';

const componentName = 'ui-visual-binary-tree';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<VisualBinaryTreeProps>();
const changableProps = useChangableProps(componentName, props);

</script>
